module.exports = __webpack_public_path__ + "img/banner3.87fc3232.jpg";